define('core/collections/UserCollection',[
    'jquery',
    'backbone',

    'core/models/User',
], function (
    $,
    Backbone,

    User
) {
    'use strict';

    var UserCollection = Backbone.Collection.extend({
        model: User,

        initialize: function (_models, options) {
            Backbone.Collection.prototype.initialize.apply(this, arguments);

            this.thread = options && options.thread;
        },

        // this is a client-only collection so return an already resolved promise
        fetch: function () {
            return $.when(true);
        },
    });

    return UserCollection;
});

